<template>
  <v-app id="inspire">
    <router-view style="min-height:100%; padding-bottom: 80px"></router-view>
    <!-- Footer-->
    <footer
      class="page-footer font-small bg-light py-5"
      style="margin-top: -80px !important;"
    >
      <div class="container">
        <div class="small text-center text-muted">
          Copyright © 2021 - <a href="https://acdc.vision.ee.ethz.ch">ACDC</a>
        </div>
      </div>
    </footer>
  </v-app>
</template>

<style lang="scss">
@import "style/_variables.scss";
@import "node_modules/bootstrap/scss/bootstrap.scss";
@import "style/overall.scss";

.page-section {
  padding: 4rem 0;
}
</style>

<script>
import { mapState, mapActions } from "vuex";
import { authRequired } from "@/router";
import { Config } from "@/config";

export default {
  name: "app",

  data() {
    return {
      datasets: Config.datasets
    };
  },
  computed: {
    ...mapState({
      alert: state => state.alert
    })
  },
  methods: {
    ...mapActions({
      clearAlert: "api/clear"
    }),
    ...mapActions("api", ["logout"]),
    logoutUser() {
      this.logout();
      if (authRequired(this.$router.currentRoute)) {
        this.$router.push("/");
      }
    },
    loginUser() {
      const currentPath = this.$router.currentRoute.path;
      this.$router.push("/login?target=" + currentPath);
    }
  },
  watch: {
    $route(to, from) {
      // clear alert on location change
      this.clearAlert();
    }
  }
};
</script>
